export class ReviewReport {
    constructor(review_report) {
        this.total_survey                      = review_report.total_survey;
        this.customer_write_review_into_system = review_report.customer_write_review_into_system;
        this.google_review_at_sign_up          = review_report.google_review_at_sign_up ? new GoogleReviewAtSignUp(review_report.google_review_at_sign_up) : null;
        this.google_review_current             = review_report.google_review_current ? new GoogleReviewCurrent(review_report.google_review_current) : null;
        this.customer_give_rating_into_system  = review_report.customer_give_rating_into_system ? new CustomerGiveRatingIntoSystem(review_report.customer_give_rating_into_system) : null;
        this.total_gocheckin_review            = review_report.total_gocheckin_review;
        this.total_yelp_review                 = review_report.total_yelp_review;
        this.total_google_review               = review_report.total_google_review;
        this.yelp_review_rating                = review_report.yelp_review_rating ? new YelpReviewRating(review_report.yelp_review_rating) : null;
        this.google_review_rating              = review_report.google_review_rating ? new GoogleReviewRating(review_report.google_review_rating) : null;
    }
}

class GoogleReviewAtSignUp {
    constructor(google_review_at_sign_up) {
        this.average_rating = google_review_at_sign_up.average_rating;
        this.total_reviews = google_review_at_sign_up.total_reviews;
    }
}

class GoogleReviewCurrent {
    constructor(google_review_current) {
        this.average_rating = google_review_current.average_rating;
        this.total_reviews = google_review_current.total_reviews;
    }
}

class CustomerGiveRatingIntoSystem {
    constructor(customer_give_rating_into_system) {
        this.five_star = customer_give_rating_into_system.five_star;
        this.four_star = customer_give_rating_into_system.four_star;
        this.three_star = customer_give_rating_into_system.three_star;
        this.two_star = customer_give_rating_into_system.two_star;
        this.one_star = customer_give_rating_into_system.one_star;
    }
}

class YelpReviewRating {
    constructor(yelp_review_rating) {
        this.five_star = yelp_review_rating.five_star;
        this.four_star = yelp_review_rating.four_star;
        this.three_star = yelp_review_rating.three_star;
        this.two_star = yelp_review_rating.wo_star;
        this.one_star = yelp_review_rating.one_star;
    }
}

class GoogleReviewRating {
    constructor(google_review_rating) {
        this.five_star = google_review_rating.five_star;
        this.four_star = google_review_rating.four_star;
        this.three_star = google_review_rating.three_star;
        this.two_star = google_review_rating.wo_star;
        this.one_star = google_review_rating.one_star;
    }
}